import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import * as RoleActions from './role.actions';
import {
  catchError,
  map,
  mergeMap,
  switchMap,
  tap,
  throttleTime,
} from 'rxjs/operators';
import { from, Observable, of } from 'rxjs';
import { RoleService } from '../../backend/role/role.service';
import { RoleModel } from '../../backend/role/model/role.model';
import {
  HideSpinner,
  ShowSpinner,
} from '../../../shared/spinner/spinner.action';
import { Action } from '@ngrx/store';
import * as ErrorActions from '../../error/error.actions';
import { ErrorType } from '../../error/model/error-type';

type showSpinnerTypes = RoleActions.RolesRequest;

const showSpinnerActions = [RoleActions.ROLES_REQUEST];

type hideSpinnerTypes = RoleActions.RolesReceive;

const hideSpinnerActions = [RoleActions.ROLES_RECEIVE];
@Injectable()
export class RoleEffects {
  constructor(private actions$: Actions, private roleService: RoleService) {}

  @Effect()
  showSpinner: Observable<Action> = this.actions$.pipe(
    ofType<showSpinnerTypes>(...showSpinnerActions),
    map(() => new ShowSpinner())
  );

  @Effect()
  hideSpinner: Observable<Action> = this.actions$.pipe(
    ofType<hideSpinnerTypes>(...hideSpinnerActions),
    map(() => new HideSpinner())
  );

  @Effect()
  OnRolesRequest$ = this.actions$.pipe(
    ofType<RoleActions.RolesRequest>(RoleActions.ROLES_REQUEST),
    throttleTime(2000),
    switchMap(() =>
      from(this.roleService.getAllRoles()).pipe(
        mergeMap((roles: RoleModel[]) => [new RoleActions.RolesReceive(roles)]),
        catchError((data) =>
          of(
            new ErrorActions.ErrorReceive({
              message: data.error.message,
              type: ErrorType.token,
              statusCode: data.status,
            })
          )
        )
      )
    )
  );
}
